var _rect, _path, _path2, _g, _path3, _path4, _path5, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBombmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    viewBox: "0 0 142 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 44,
    rx: 7.5,
    fill: "#27191B",
    stroke: "url(#paint0_linear_621_421)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3144 2.95136C74.6742 2.57504 73.8556 2.79837 73.486 3.45017L71.1142 7.63296C70.0466 7.44494 68.948 7.34688 67.8265 7.34688C57.4289 7.34688 49 15.7758 49 26.1734C49 36.571 57.4289 44.9999 67.8265 44.9999C78.2241 44.9999 86.6531 36.571 86.6531 26.1734C86.6531 20.7725 84.3788 15.9028 80.7357 12.4696L82.7592 8.90127C83.1288 8.24947 82.9094 7.41601 82.2692 7.03969L75.3144 2.95136Z",
    fill: "#34384F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.0902 0.00511045C87.2754 -0.109197 90.1008 1.7157 91.7094 3.30835C92.2402 3.83386 92.2402 4.68589 91.7094 5.2114C91.1786 5.73691 90.318 5.73691 89.7872 5.2114C88.451 3.88845 86.3155 2.61833 84.1887 2.69466C82.2445 2.76443 79.7814 3.99496 77.7298 8.81904C77.4385 9.50399 76.6416 9.82546 75.9498 9.53706C75.2579 9.24866 74.9332 8.4596 75.2245 7.77466C77.5223 2.37173 80.7224 0.125973 84.0902 0.00511045Z",
    fill: "#FF9299"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_621_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.486 3.45022C73.8556 2.79841 74.6742 2.57509 75.3144 2.95141L82.2692 7.03973C82.9094 7.41605 83.1288 8.24951 82.7592 8.90132L79.3954 14.8333L70.1223 9.38219L73.486 3.45022Z",
    fill: "#34384F"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4031 26.1735C86.4031 36.433 78.0861 44.75 67.8265 44.75C57.567 44.75 49.25 36.433 49.25 26.1735C49.25 15.9139 57.567 7.59692 67.8265 7.59692C78.0861 7.59692 86.4031 15.9139 86.4031 26.1735Z",
    fill: "#34384F",
    stroke: "url(#paint1_linear_621_421)",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7348 25.8924C85.7348 35.6853 77.6629 43.6225 67.7058 43.6225C64.1539 43.628 60.6802 42.5968 57.7246 40.6596C60.1508 41.7239 62.7783 42.272 65.435 42.268C75.8862 42.268 84.3583 33.9371 84.3583 23.6592C84.3632 21.0448 83.8059 18.459 82.7228 16.0715C84.6933 18.9797 85.7416 22.3977 85.7348 25.8924Z",
    fill: "url(#paint2_linear_621_421)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M55.0505 21.1406C54.6161 24.2857 57.1295 27.7973 57.1295 27.7973L56.7073 30.9528L59.0528 31.749L59.8441 28.629L60.7121 28.6705L60.6078 32.2747L63.2287 32.4951L63.7324 29.2791C63.7324 29.2791 64.4716 29.2238 64.5759 29.3033C64.6802 29.3829 64.3575 32.9023 64.3575 32.9023L66.7087 33L67.1602 29.4252C69.024 29.2653 72.1511 27.244 72.8112 24.4586C73.7346 20.9426 71.288 16.0952 65.0844 15.1477C58.8808 14.2002 55.4865 17.9998 55.0505 21.1406ZM67.4658 20.5855C68.531 21.0558 68.9531 22.5627 68.4087 23.9502C67.8643 25.3378 66.5595 26.0813 65.4927 25.6101C64.4259 25.139 64.0054 23.6364 64.5523 22.248C65.0991 20.8596 66.4006 20.1178 67.4658 20.5881V20.5855ZM59.9069 19.23C60.8523 19.3294 61.5238 20.4109 61.4081 21.6428C61.2924 22.8748 60.4301 23.7894 59.4839 23.6892C58.5377 23.5889 57.8662 22.5082 57.9827 21.2772C58.0993 20.0461 58.9591 19.128 59.9069 19.23Z",
    fill: "url(#paint3_linear_621_421)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_621_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5 33C72.299 33 77 28.0751 77 22C77 15.9249 72.299 11 66.5 11C60.701 11 56 15.9249 56 22C56 28.0751 60.701 33 66.5 33Z",
    fill: "url(#paint4_radial_621_421)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_621_521",
    x: 70.1223,
    y: -1.23145,
    width: 12.8164,
    height: 16.0647,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_621_521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_621_521",
    x: 46,
    y: 1,
    width: 41,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_621_521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_621_421",
    x1: 71,
    y1: 0,
    x2: 71,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82F2F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_621_421",
    x1: 54.5,
    y1: 13.5,
    x2: 68,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686C88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_621_421",
    x1: 71.7297,
    y1: 16.0715,
    x2: 71.7297,
    y2: 43.6226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#704F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704F4F",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_621_421",
    x1: 64,
    y1: 15,
    x2: 64,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C9C9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_621_421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.5 22) rotate(90) scale(11 10.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBombmedium);
export default __webpack_public_path__ + "static/media/bombmedium.2c4111ccb6ef703065015b7595c61e1f.svg";
export { ForwardRef as ReactComponent };